import { Component } from 'lib'
import Image from 'Component/Asset/Image/Image'
import locale from 'Common/Locale/Locale'
import Icon from 'Component/Asset/Icon/Icon'

const CLAIMABLE_DURATION_IN_MILLISECONDS = 60 * 60 * 24 * 2 * 1000

function getIsOperaGx () {
  const userAgentData = window.navigator.userAgentData

  const hasNavData = userAgentData
    ?.toString()
    .startsWith('[object NavigatorUAData]')

  const hasOperaBrand = userAgentData?.brands.some(
    (item) => item.brand === 'Opera GX'
  )

  return hasNavData && hasOperaBrand
}

const operaClaimBaseUrl = new URL(
  '/claim-opera',
  `https:${window.location.hostname
    .replace(/^local\./, 'dev.beta.')
    .replace(/\.legacy\./, '.beta.')}`
)

class OperaClaimReward extends Component {
  constructor (props) {
    super(props)

    this.claim = this.claim.bind(this)

    const isExpired
      = props.unlockedDateMillis + CLAIMABLE_DURATION_IN_MILLISECONDS
      < new Date().getTime()

    this.state = {
      isLoading: !isExpired && getIsOperaGx()
    }
  }

  componentDidMount () {
    const isExpired
      = this.props.unlockedDateMillis + CLAIMABLE_DURATION_IN_MILLISECONDS
      < new Date().getTime()

    if (isExpired || !getIsOperaGx()) {
      return
    }

    const getClaimStatusUrl = new URL(operaClaimBaseUrl)

    getClaimStatusUrl.searchParams.set('id', this.props.dropId)

    fetch(getClaimStatusUrl, {
      credentials: 'include'
    })
      .then((response) => response.json())
      .then(({ isClaimed }) => {
        this.setState({ isClaimed })
      })
      .finally(() => {
        this.setState({ isLoading: false })
      })
  }

  claim () {
    const isExpired
      = this.props.unlockedDateMillis + CLAIMABLE_DURATION_IN_MILLISECONDS
      < new Date().getTime()

    if (
      isExpired
      || !getIsOperaGx()
      || this.state.isClaimed
      || this.state.isLoading
    ) {
      return
    }

    this.setState({ isLoading: true })

    const claimUrl = new URL(operaClaimBaseUrl)

    claimUrl.searchParams.set('id', this.props.dropId)

    fetch(claimUrl, {
      credentials: 'include',
      method: 'POST'
    })
      .then((response) => {
        this.setState({ isClaimed: response.ok })
      })
      .finally(() => {
        this.setState({ isLoading: false })
      })
  }

  render (
    { imageUrl, onToggleInstructions, title, unlockedDateMillis },
    { isClaimed, isLoading }
  ) {
    const isExpired
      = unlockedDateMillis + CLAIMABLE_DURATION_IN_MILLISECONDS
      < new Date().getTime()

    if (isExpired) {
      return (
        <div class="reward">
          <div class="wrapper">
            <div class="title">{ title }</div>
            <div class="description">
              { locale.translate('rewards.fulfillment.expired') }
            </div>
          </div>
          <div class="image">
            <Image class="img" src={ imageUrl } size="240x272"/>
          </div>
        </div>
      )
    }

    if (!getIsOperaGx()) {
      return (
        <div class="reward" onclick={ onToggleInstructions } role="button">
          <div class="wrapper">
            <div class="title">{ title }</div>
            <div class="how-to-claim">
              { locale.translate('rewards.drops.howToClaim') }
            </div>
          </div>
          <div class="image">
            <Image class="img" src={ imageUrl } size="240x272"/>
          </div>
        </div>
      )
    }

    return (
      <div class="reward">
        <div class="wrapper">
          <div class="title">{ title }</div>
          { !isLoading && (
            <div class="description">
              { isClaimed
                ? locale.translate(
                  'rewards.fulfillment.leagueOfLegends.success'
                )
                : locale.translate(
                  'rewards.fulfillment.leagueOfLegends.pending'
                ) }
            </div>
          ) }
          { isLoading ? (
            <div
              aria-label="Loading..."
              aria-live="polite"
              class="loader"
              role="status">
              <Icon name="lolesportsLogo"/>
              <Icon name="lolesportsLogo"/>
            </div>
          ) : (
            <button
              class="claim-now"
              disabled={ isClaimed }
              onClick={ this.claim }
              type="button">
              { isClaimed
                ? locale.translate('opera.claimed.button')
                : locale.translate('opera.claim.button') }
            </button>
          ) }
        </div>
        <div class="image">
          <Image class="img" src={ imageUrl } size="240x272"/>
        </div>
      </div>
    )
  }
}

export default OperaClaimReward
